import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../../common_components/mdae-framework";
import { MyTaskTimePeriodEnum } from "../../../../../common_components/user-task-card-view/component";
export const myTaskWidgetPropertiesData = {
  widgetTitle: "My Tasks",
  timePeriodValue: MyTaskTimePeriodEnum.ThisWeek,
  taskCategoryIdList: [],
  taskCategoryTypeValueList: [],
  isIncludeCanceledTasks: false,
};

const initialState = {
  isLoading: false,
  myTaskPropertiesData: myTaskWidgetPropertiesData,
};
export const TOGGLE_MY_TASK_DASHBOARD_PROPERTIES_POPUP =
  "TOGGLE_MY_TASK_DASHBOARD_PROPERTIES_POPUP";
export const SET_MY_TASK_DASHBOARD_PROPERTIES_DATA =
  "SET_MY_TASK_DASHBOARD_PROPERTIES_DATA";

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_MY_TASK_DASHBOARD_PROPERTIES_DATA:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          myTaskPropertiesData: action.data,
        };
      }
      return newState;

    case TOGGLE_MY_TASK_DASHBOARD_PROPERTIES_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          ...action.data,
          currentPropertyWidgetId: action.data.widgetId,
        };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      return state;
    default:
      return state;
  }
}
